import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdvancedGridviewComponent } from 'src/app/controls/advanced-gridview/advanced-gridview.component';
import { AdvancedDataSource } from 'src/app/controls/advanced-gridview/datasources/advanced-datasource';
import { AdvancedGridviewModel } from 'src/app/controls/advanced-gridview/models/advanced-gridview-model';
import { ColumnDefinition } from 'src/app/controls/advanced-gridview/models/column-definition';
import { ColumnType } from 'src/app/controls/advanced-gridview/models/column-type';
import { MenuITemAction } from 'src/app/controls/advanced-gridview/models/menu-item-action';
import { MenuItemEvent } from 'src/app/controls/advanced-gridview/models/menu-item-event';
import { SortInfos } from 'src/app/controls/advanced-gridview/models/sort-infos';
import { FilterType } from 'src/app/controls/filters/models/filter-type';
import { DefaultListComponent } from 'src/app/controls/list/default-list/default-list.component';
import { EnumHelper } from 'src/app/helpers/enum-helper';
import { RestApiConfiguration } from 'src/app/models/RestApiCaller/configuration/rest-api-configuration';
import { Rights } from 'src/app/models/enums/rights';
import { MemoryService } from 'src/app/services/memory.service';
import { NotificationService } from 'src/app/services/notification-service';
import { RestApiConfigurationsService } from 'src/app/services/restApi/rest-api-configurations.service';

@Component({
    selector: 'app-api-configurations-list',
    imports: [AdvancedGridviewComponent],
    templateUrl: './api-configurations-list.component.html',
    styleUrl: './api-configurations-list.component.scss'
})
export class ApiConfigurationsListComponent extends DefaultListComponent<RestApiConfiguration> implements OnInit {
    /**
     * Configuration des colonnes de la liste.
     */
    tableConfig: ColumnDefinition[] = null;

    /**
     * Constructeur
     * @param dialog : Service pour ouvrir des boites de dialogue.
     * @param memoryService : Service pour récupérer les informations en mémoire.
     * @param enumHelper : Classe utilitaire pour les énumérations.
     * @param restApiConfigurationsService : Service de gestion des processus.
     * @param boxeservice : Service de gestion des bannettes.
     */
    constructor(
        public override dialog: MatDialog,
        protected override memoryService: MemoryService,
        public enumHelper: EnumHelper,
        private restApiConfigurationsService: RestApiConfigurationsService,
        private spinner: NgxSpinnerService,
        private notificationService: NotificationService
    ) {
        super(dialog, memoryService);

        if (this.memoryService.getConnectedUser().params.idVisible === true) {
            this.tableConfig = [
                new ColumnDefinition('id', 'Id', ColumnType.Numeric, FilterType.Text, 1, 5, true),
                new ColumnDefinition('name', 'Nom', ColumnType.Text, FilterType.Text, 2, 25, true),
                new ColumnDefinition('description', 'Description', ColumnType.Text, FilterType.Text, 3, 30, true),
                new ColumnDefinition('contextOfUse', "Contexte d'utilisation", ColumnType.Text, FilterType.Text, 3, 20, true),
                new ColumnDefinition('updateDate', 'Date de mise à jour', ColumnType.DateAndTime, FilterType.Text, 3, 15, true),
            ];
        } else {
            this.tableConfig = [
                new ColumnDefinition('name', 'Nom', ColumnType.Text, FilterType.Text, 2, 25, true),
                new ColumnDefinition('description', 'Description', ColumnType.Text, FilterType.Text, 3, 35, true),
                new ColumnDefinition('contextOfUse', "Contexte d'utilisation", ColumnType.Text, FilterType.Text, 3, 20, true),
                new ColumnDefinition('updateDate', 'Date de mise à jour', ColumnType.DateAndTime, FilterType.Text, 3, 15, true),
            ];
        }

        this.AddMenuItem('Dupliquer', MenuITemAction.Duplicate, Rights.ProcessCreate);
        this.AddMenuItem('Éditer', MenuITemAction.Update, Rights.ProcessEdit);
        this.AddMenuItem('Supprimer', MenuITemAction.Delete, Rights.ProcessDelete);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        this.dataSource = new AdvancedDataSource(null, this.restApiConfigurationsService, this.spinner, this.notificationService);
        this.filteredTableModel = new AdvancedGridviewModel(this.tableConfig, new SortInfos('name', 'asc'));
    }

    /**
     * Appellé lorsque l'utilisateur clique sur un élément du menu contextuel.
     * @param event : Événement retourné par le menu contextuel.
     */
    public onAction(event: MenuItemEvent<RestApiConfiguration>): void {
        if (event.action == MenuITemAction.Read) {
            // Cas de la consultation.
            this.itemDisplayed.emit(event.context);
        } else if (event.action == MenuITemAction.Update) {
            // Cas de la mise à jour.
            this.itemEdited.emit(event.context);
        } else if (event.action == MenuITemAction.Duplicate) {
            // Cas de duplication.
            this.itemDuplicated.emit(event.context);
        } else if (event.action == MenuITemAction.Delete) {
            // Cas de la suppression --> affichage de la boite de dialogue de confirmation.
            this.displayDeleteConfirmationDialog(`Vous êtes sur le point de supprimer la configuration d'API '${event.context.name}'.`, event.context);
        }
    }
}
